/**
 * @ngdoc component
 * @name  common.product.component:ItxProductPrices
 * @description
 * Shows product price 
 * @param {object} product - Product Object
 * @param {object} color - Color Object
 * @param {boolean} summation - Boolean to get the total price of a product
 * 
*/
(function () {

    'use strict';

    var ItxProductPricesCmp = {
        bindings: {
            product: '<',
            color: '<',
            summation:'<',
            textView: '<',
            showPercent: '<',
            hideFuturePrice: '<',
            onExternalPercentage: '&'
        },
        controller: ItxProductPricesCmpCtrl,
        templateUrl: 'ItxProductPrices.html'
    };
    
    angular.module('itxApp.common')
        .component('itxProductPrices', ItxProductPricesCmp);

    ItxProductPricesCmpCtrl.$inject = ['ItxConfigurationSvc', 'CommonServices', 'AkamaiDateSvc', '$q', 'CmsConfigSvc', 'ItxUtilsFct', 'NavigationService'];

    function ItxProductPricesCmpCtrl(ItxConfigurationSvc, CommonServices, AkamaiDateSvc, $q, CmsConfigSvc, ItxUtilsFct, NavigationService) {
        
        var _this = this;

        _this.$onInit = function () {
            _initPrices();
        };

        _this.$onChanges = function (changes) {
            if(changes.color && !changes.color.isFirstChange() && changes.color.currentValue != changes.color.previousValue){
                _initPrices();
            }
        };

        function _initPrices() {
            _this.showFuturePrice = false;
            const isPrivateSales = CommonServices.privateSalesEnabled();
            _this.isGridOrProductView = NavigationService.isCategoryPage() || NavigationService.isProductPage();
            const canShowFuturePrices = _this.isGridOrProductView && !hasOldPrice();
            if(!isPrivateSales && canShowFuturePrices && !_this.hideFuturePrice){
                handleFuturePrice();
            }
        }

        _this.getRanges = function () {
            if(!_this.product) {return;}
            var prices = {};
            if(_this.summation){
                _this.sumationPrice = joyr.catalog.utils.getSummationBundlePricesShortestSize(_this.product);
                if(_this.sumationPrice != 0){
                    _this.sumationPrice = inditex.formatPrice(_this.sumationPrice);
                    prices.price = checkColbensonPrices( String(_this.sumationPrice));
                } else {
                    prices.price = 0;
                }
                return prices;
            }

            _this.product.maxOldPrice = checkColbensonPrices(_this.product.maxOldPrice);
            _this.product.maxPrice = checkColbensonPrices(_this.product.maxPrice);
            _this.product.minOldPrice = checkColbensonPrices(_this.product.minOldPrice);
            _this.product.minPrice = checkColbensonPrices(_this.product.minPrice);
            var ranges = joyr.catalog.utils.getProductPriceRanges(_this.product, _this.color, _this.product.state.selectedSize);
            
            if (!ranges) {
                return;
            }

            if (ranges.minPrice || ranges.maxPrice) {
                prices.price = joyr.catalog.utils.getProductPriceRangesHtml({
                    min: ranges.minPrice,
                    max: ranges.maxPrice
                });

                // Precio alternativos
                if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                    const priceAlternates = Math.round(ranges.minPrice * inditex.iStoreJSON.details.alternateLocales[0].conversionRate);
                    prices.priceAlternates = inditex.formatPriceForCurrency(priceAlternates, inditex.iStoreJSON.details.alternateLocales[0]);
                }

                if(prices.price && prices.price.indexOf('0.00') === 0){
                    prices.price = 0;

                    // Precio alternativos
                    if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                        prices.priceAlternates = 0;
                    }
                }
            } else {
                prices.price = 0;

                // Precio alternativos
                if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                    prices.priceAlternates = 0;
                }
            }

            if (ranges.minOldPrice || ranges.maxOldPrice) {
                prices.oldPrice = joyr.catalog.utils.getProductPriceRangesHtml({
                    min: ranges.minOldPrice,
                    max: ranges.maxOldPrice
                });

                // Precio alternativos
                if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                    const oldPriceAlternates = Math.round(ranges.minOldPrice * inditex.iStoreJSON.details.alternateLocales[0].conversionRate);
                    prices.oldPriceAlternates = inditex.formatPriceForCurrency(oldPriceAlternates, inditex.iStoreJSON.details.alternateLocales[0]);
                }

                if(prices.oldPrice && prices.oldPrice.indexOf('0.00') === 0){
                    prices.oldPrice = 0;

                    // Precio alternativos
                    if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                        prices.oldPriceAlternates = 0;
                    }
                }
            } else {
                prices.oldPrice = 0;

                // Precio alternativos
                if (inditex.iStoreJSON.details.alternateLocales && inditex.iStoreJSON.details.alternateLocales.length > 0) {
                    prices.oldPriceAlternates = 0;
                }
            }

            try {
                _this.percent = _getPercent(ranges);
            } catch (error) {
                _this.percent = 0;
            }

            if(_this.percent == 0 || _this.percent == 100 || _this.isGridOrProductView){
                _this.showPercent = false;
            }

            if(_this.percent !== 0 && _this.percent !== 100 && _this.isGridOrProductView && _this.onExternalPercentage){
                _this.onExternalPercentage({percentage: _this.percent});
            }

            return prices;
        };

        function handleFuturePrice() {
            const futurePriceObject = getFuturePrice();
            if(futurePriceObject && futurePriceObject.price){
                getTodayOrTomorrow()
                .then(todayOrTomorrow => {
                    if(todayOrTomorrow === 'today' || todayOrTomorrow === 'tomorrow'){
                        CommonServices.isVip()
                        .then(isVip => {
                            let vipString = 'vip';
                            if(!isVip){
                                vipString = 'novip';
                            }
                            _this.futurePrice = inditex.formatPrice(futurePriceObject.price);
                            const futurePercentage = getFuturePercentage(futurePriceObject.price);
                            if(_this.onExternalPercentage){
                                _this.onExternalPercentage({percentage: futurePercentage});
                            }
                            _this.futurePriceKey = `dev.product.prewarming.${todayOrTomorrow}.${vipString}.message`;
                            _this.showFuturePrice = true;
                        });
                    }
                });
            }
        }

        function hasOldPrice() {
            const size = getFirstSize();

            if(size){
                const hasOldPrice = (size.price && size.oldPrice) || false;
                return hasOldPrice;
            }

            return false;
        }

        function getCurrentPrice() {
            const size = getFirstSize();

            if(size) {
                return size.price;
            }

            return undefined;
        }

        function getFuturePercentage(futurePrice) {
            const currentPrice = getCurrentPrice();
            const sumPercentage = Math.round( (futurePrice / currentPrice) * 100 );
            const unroundedPercentage = 100 - sumPercentage;
            const roundedPercentage = _roundPercentage(unroundedPercentage);

            return roundedPercentage;
        }

        function getTodayOrTomorrow() {
            var deferred = $q.defer();
            CmsConfigSvc.getProperty('prewarm_config')
            .then(prewarmDates => {
                if(prewarmDatesCorrectlyInformed(prewarmDates)){
                    const tz = ItxUtilsFct.getTimeZone();
                    AkamaiDateSvc.getLocalDate(tz)
                    .then(localDate => {
                        const isToday = checkDateBetweenPrewarm(localDate, prewarmDates.today, tz);
                        const isTomorrow = checkDateBetweenPrewarm(localDate, prewarmDates.tomorrow, tz);

                        let output = undefined;
                        if(isToday){
                            output = 'today';
                        } else if (isTomorrow){
                            output = 'tomorrow';
                        }

                        deferred.resolve(output);
                    });
                } else {
                    deferred.reject();    
                }
            })
            .catch(() => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function checkDateBetweenPrewarm(date, prewarm, tz){
            const initPrewarmDate = moment.tz(prewarm.from, 'YYYY-MM-DD HH:mm:ss', tz);
            const endPrewarmDate = moment.tz(prewarm.to, 'YYYY-MM-DD HH:mm:ss', tz);
            const result = date.isBetween(initPrewarmDate, endPrewarmDate);

            return result;
        }

        function prewarmDatesCorrectlyInformed(prewarmDates) {
            if(prewarmDates){
                const tomorrow = prewarmDates.tomorrow;
                const today = prewarmDates.today;
                if(tomorrow && today){
                    const tomorrowCorrect = tomorrow.from && tomorrow.to;
                    const todayCorrect = today.from && today.to;
                    return tomorrowCorrect && todayCorrect;
                }
            }

            return false;
        }

        function getFirstSize() {
            if(_this.product){
                const detail = _this.product.detail;
                if(detail && detail.colors && detail.colors.length > 0){
                    var indexColor = 0;
                    if(_this.product.state && _this.product.state.selectedColorIndex){
                        indexColor = _this.product.state.selectedColorIndex;
                    }
                    const color = detail.colors[indexColor];
                    if(color && color.sizes && color.sizes.length > 0){
                        const size = color.sizes[0];
                        return size;
                    }
                }
            }

            return undefined;
        }

        function getFuturePrice() {
            const size = getFirstSize();

            if(size){
                return size.futurePrice;
            }

            return undefined;
        }

        function checkColbensonPrices(price) {
            if (price && price.indexOf && price.indexOf('.') > -1) {
                var splitted = price.split('.');
                price = splitted[0] + '.' + _.padEnd(splitted[1], -inditex.iStoreJSON.details.locale.currencyDecimals, '0');
            }
            return price;
        }

        _this.ivaEnabled = ItxConfigurationSvc.get('ivaEnabled');

        function _roundPercentage(percentage){
            return Math.round(percentage/5)*5;
        }

        function _getPercent(prices){
            var percent;
            if(!prices.maxPrice || !prices.minPrice || !prices.maxOldPrice || !prices.minOldPrice){
                return 0;
            }
            if(prices.maxPrice == prices.minPrice && prices.maxOldPrice == prices.minOldPrice){
                let oldPrice = prices.maxOldPrice;
                let price = prices.maxPrice;
                if(oldPrice && oldPrice != 0 && price && price != 0) {
                    let intPercent = Math.round( (price / oldPrice) * 100 );    
                    if(intPercent > 0 && intPercent < 100){
                        percent = intPercent;
                    } else {
                        percent = 0;
                    }
                } else {
                    percent = 0;
                }      
            } else {
                percent = 0;
            }
            let unroundedPercentage = 100 - percent;
            let roundedPercentage = _roundPercentage(unroundedPercentage);
            return roundedPercentage;
        }
    }

})();
